import { listPageTabTestIdentifier } from '@/utils/flightDeckTestIds';

export type AkoniCustomerTab = 'all' | 'individuals' | 'businesses';

export const AKONI_CUSTOMER_TABS = [
  {
    text: 'All',
    value: 'all' as const,
    id: 'all',
    testIdentifier: listPageTabTestIdentifier('akoni-customers', 'all')
  },
  {
    text: 'Individuals',
    value: 'individuals' as const,
    id: 'individuals',
    testIdentifier: listPageTabTestIdentifier('akoni-customers', 'individuals')
  },
  {
    text: 'Businesses',
    value: 'businesses' as const,
    id: 'businesses',
    testIdentifier: listPageTabTestIdentifier('akoni-customers', 'businesses')
  }
];

export function parseAkoniCustomerTab(value: string | null): AkoniCustomerTab {
  if (value === 'individuals' || value === 'businesses') return value;
  return 'all';
}

export function getAkoniCustomerTypeFilter(
  tab: AkoniCustomerTab
): string | undefined {
  if (tab === 'individuals') return 'Individual';
  if (tab === 'businesses') return 'Business';
  return undefined;
}

export function isClosedDepositStatus(status?: string): boolean {
  if (!status) return false;
  const normalised = status.toLowerCase();
  return (
    normalised.includes('closed') ||
    normalised.includes('matured') ||
    normalised.includes('withdrawn')
  );
}
